<div class="staff-manager">
  <div class="container">
    <div class="header">
      <h1>Gerenciamento de Staff</h1>
      <button *ngIf="selectedEvent" class="btn-back" (click)="goBack()">
        ← Voltar
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading">
      <div class="spinner"></div>
      <p>Carregando...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error" class="error">
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="loadOngoingEvents()">Tentar novamente</button>
    </div>

    <!-- Lista de Eventos -->
    <div *ngIf="!loading && !error && !selectedEvent" class="events-list">
      <h2>Eventos em Andamento</h2>
      <div class="cards-grid" *ngIf="events.length > 0">
        <div
          *ngFor="let event of events"
          class="event-card"
          (click)="selectEvent(event)"
        >
          <h3>{{ event.name }}</h3>
          <p class="event-dates">
            <strong>Início:</strong> {{ event.startAt | date:'dd/MM/yyyy HH:mm' }}<br>
            <strong>Fim:</strong> {{ event.endAt | date:'dd/MM/yyyy HH:mm' }}
          </p>
          <p *ngIf="event.observation" class="event-observation">
            {{ event.observation }}
          </p>
        </div>
      </div>
      <div *ngIf="events.length === 0" class="no-events">
        <p>Nenhum evento em andamento encontrado.</p>
      </div>
    </div>

    <!-- Detalhes do Evento e Jobs -->
    <div *ngIf="!loading && !error && selectedEvent && selectedCelebration && !selectedJob" class="celebration-detail">
      <h2>{{ selectedCelebration.name }}</h2>
      <div class="celebration-info">
        <p><strong>Observação:</strong> {{ selectedCelebration.observation }}</p>
        <div class="stats">
          <div class="stat">
            <span class="label">Staff Ativo:</span>
            <span class="value">{{ selectedCelebration.activeStaff }}</span>
          </div>
          <div class="stat">
            <span class="label">Staff Agendado:</span>
            <span class="value">{{ selectedCelebration.scheduledStaff }}</span>
          </div>
          <div class="stat">
            <span class="label">Mín/Máx:</span>
            <span class="value">{{ selectedCelebration.minStaff }}/{{ selectedCelebration.maxStaff }}</span>
          </div>
        </div>
      </div>

      <h3>Jobs Disponíveis</h3>
      <div class="cards-grid">
        <div
          *ngFor="let job of selectedCelebration.jobList"
          class="job-card"
          (click)="selectJob(job)"
        >
          <h4>{{ job.name }}</h4>
          <p>{{ job.description }}</p>
          <div class="job-stats">
            <span>Ativo: {{ job.activeStaff }}</span>
            <span>Agendado: {{ job.scheduledStaff }}</span>
            <span>Locais: {{ job.locationList.length }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de Locations -->
    <div *ngIf="!loading && !error && selectedJob && !selectedLocation" class="locations-list">
      <h2>{{ selectedJob.name }}</h2>
      <p>{{ selectedJob.description }}</p>

      <h3>Localizações</h3>
      <div class="cards-grid">
        <div
          *ngFor="let location of selectedJob.locationList"
          class="location-card"
          (click)="selectLocation(location)"
        >
          <h4>{{ location.name }}</h4>
          <p>{{ location.description }}</p>          <div class="location-stats">
            <div class="stat">
              <span class="label">Staff Ativo:</span>
              <span class="value">{{ location.activeStaff }}</span>
            </div>
            <div class="stat">
              <span class="label">Staff Agendado:</span>
              <span class="value">{{ location.scheduledStaff }}</span>
            </div>
            <div class="stat">
              <span class="label">Capacidade:</span>
              <span class="value">{{ location.minStaff }}-{{ location.maxStaff }}</span>
            </div>
            <div class="stat">
              <span class="label">Prioridade:</span>
              <span class="value">{{ location.priority }}</span>
            </div>
            <div class="stat">
              <span class="label">Tempo Padrão:</span>
              <span class="value">{{ formatMinutesToHoursMinutes(location.defaultJobTimeInMinutes) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de Staff -->
    <div *ngIf="!loading && !error && selectedLocation && staffLocationDetail" class="staff-list">
      <h2>{{ selectedLocation.name }}</h2>
      <p>{{ selectedLocation.description }}</p>

      <!-- Filtros -->
      <div class="filters">
        <label for="statusFilter">Filtrar por status:</label>
        <select id="statusFilter" [(ngModel)]="filterStatus">
          <option value="all">Todos</option>
          <option value="start">Iniciado</option>
          <option value="scheduled">Agendado</option>
          <option value="end_success">Concluído</option>
        </select>
      </div>

      <!-- Staff Cards -->
      <div class="staff-grid">
        <div
          *ngFor="let staff of getFilteredStaff()"
          class="staff-card"
          [ngClass]="getStaffStatusClass(staff.currentEvent.eventType.eventTypeEnum)"
        >
          <div class="staff-header">
            <h4>{{ staff.member.nomeColete }}</h4>
            <div class="staff-header-right">
              <span class="status-badge" [ngClass]="getStaffStatusClass(staff.currentEvent.eventType.eventTypeEnum)">
                {{ getStaffStatusText(staff.currentEvent.eventType.eventTypeEnum) }}
              </span>
              <button mat-icon-button
                      class="acoes-trigger"
                      [matMenuTriggerFor]="menuAcoes"
                      matTooltip="Registrar ação">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menuAcoes="matMenu">
                <button mat-menu-item
                        *ngFor="let acao of ACOES"
                        [disabled]="!isAcaoPermitida(acao, staff)"
                        (click)="abrirConfirmacao(staff, acao)">
                  <mat-icon>{{ acao.icone }}</mat-icon>
                  <span>{{ acao.label }}</span>
                </button>
              </mat-menu>
            </div>
          </div>

          <div class="staff-info">
            <!-- <p><strong>Nome:</strong> {{ staff.member.nomeCompleto }}</p> -->
            <!-- <p><strong>Número:</strong> {{ staff.member.numeroSistema }}</p> -->
            <p><strong>Regional:</strong> {{ staff.member.regional }}</p>
            <p><strong>Cargo:</strong> {{ staff.member.cargo }}</p>
            <p><strong>Telefone:</strong> {{ staff.member.telefoneCelular }} </p>
            <a *ngIf="staff.member.telefoneCelular "
                [href]="getWhatsappLink(staff.member.telefoneCelular )"
                target="_blank"
                rel="noopener"
                class="whatsapp-link"
                title="Enviar mensagem no WhatsApp">
                <img src="/assets/images/WhatsApp.png" alt="WhatsApp" style="height: 22px; vertical-align: middle;" />
              </a>
          </div>

          <div class="staff-event">
            <!-- <p><strong>Evento Atual:</strong> {{ staff.currentEvent.eventType.name }}</p> -->
            <p><strong>Descrição:</strong> {{ staff.currentEvent.description }}</p>
            <!-- <p><strong>Responsável:</strong> {{ staff.currentEvent.doneBy.name }}</p> -->
            <p><strong>Início:</strong> {{ staff.startAt | date:'dd/MM/yyyy HH:mm' }}</p>
            <p *ngIf="staff.endAt"><strong>Fim:</strong> {{ staff.endAt | date:'dd/MM/yyyy HH:mm' }}</p>
          </div>
        </div>
      </div>

      <div *ngIf="getFilteredStaff().length === 0" class="no-staff">
        <p>Nenhum staff encontrado com o filtro selecionado.</p>
      </div>

      <!-- Rodapé — fila de sincronização -->
      <div class="sync-footer">
        <div class="fila-info" [class.online]="isOnline" [class.offline]="!isOnline">
          <mat-icon [class.fila-pendente]="filaCount > 0">
            {{ filaCount > 0 ? 'pending_actions' : 'cloud_done' }}
          </mat-icon>
          <span>
            <strong>{{ filaCount }}</strong>
            {{ filaCount === 1 ? 'registro pendente' : 'registros pendentes' }}
            <em *ngIf="!isOnline"> — offline</em>
          </span>
        </div>

        <button mat-flat-button
                color="primary"
                (click)="sincronizar()"
                [disabled]="isSyncing || filaCount === 0">
          <mat-icon>{{ isSyncing ? 'hourglass_top' : 'cloud_upload' }}</mat-icon>
          {{ isSyncing ? 'Sincronizando...' : 'Sincronizar' }}
        </button>
      </div>
    </div>
  </div>
</div>
